import { message } from '@whalecloud/fdx';
import uniqBy from 'lodash/uniqBy';
import { i18n } from 'fishx';
import {
  queryRoles,
  queryPortals,
  queryRolePortal,
  editRole,
  deleteRole,
  changeRolePortal,
  qryDirsByParty,
  qryMenuListByRoleParty,
  qryMenuListByRole,
  qryDirsByDir,
  qryMenuListByDirId,
  changeRoleMenu,
  qryServiceByRole,
  deleteRoleService,
  editRoleService,
  addRoleService,
  queryPrivileges,
  queryRolePrivilege,
  changeRolePrivilege,
  queryRoleComponent,
  qryDirmenusByParty,
  queryComponentByMenu,
  qryPorletByPortal,
  qryPorletByRole,
  qryType,
  qryPorletByType,
  changeRolePortlet,
  deleteRolePortal,
  qryRoleData,
  qryDataPrivs,
  addRoleDataPrivs,
} from '@pages/RoleMgr/services/role';

const formatter = (data, parentId = null, parentType = null) => {
  if (data.length <= 0) return [];
  return data
    .map(item => {
      const result = {
        ...item,
        partyId: item.partyId ? item.partyId : 0,
        key: item.seq ? `${item.portalId}_${item.seq}` : item.portalId.toString(),
        title: item.partyName ? item.partyName : item.portalName,
      };
      if (parseInt(item.type, 10) === 0) result.children = [];
      else result.isLeaf = true;
      if (parentId) {
        result.parentId = parentId;
        result.parentType = parentType;
      }
      return result;
    })
    .filter(item => item);
};

const formatterDirs = data => {
  if (data.length <= 0) return [];
  return data
    .map(item => {
      const result = {
        ...item,
        parentId: item.parentId || -1,
        key: item.dirId.toString(),
        title: item.dirName,
        children: [],
      };
      return result;
    })
    .filter(item => item);
};

// 数组转树型结构
const arrayToTree = (array, id = 'partyId', pId = 'parentId', children = 'children') => {
  const data = JSON.parse(JSON.stringify(array));
  const hash = {};
  const result = [];
  data.forEach((item, index) => {
    const etem = item;
    if (etem.parentId) {
      hash[data[index][id]] = data[index];
    } else {
      etem.children = [];
      result.push(etem);
    }
  });

  data.forEach(item => {
    if (item[pId]) {
      const hashVP = hash[item[pId]];
      const { parentType, partyId } = item;
      if ((hashVP && parentType === 'portalId' && partyId === 0) || (hashVP && parentType !== 'portalId' && partyId !== 0)) {
        if (!hashVP[children]) {
          hashVP[children] = [];
        }
        hashVP[children].push(item);
      }
    }
  });

  result.forEach(item => {
    Object.keys(hash).forEach(key => {
      const { parentType } = hash[key];
      if (item[parentType] === hash[key][parentType]) {
        item.children.push(hash[key]);
      }
    });
  });
  return result;
};

export default {
  namespace: 'roleMgr',

  state: {
    list: [],
    currentUser: {},
    selectItem: {},
    roleList: [],
    upList: [],
    downList: [],
    arrayList: [],
    menuTree: [],
    serviceList: [],
    tabKey: 'portal',
  },

  effects: {
    *queryRoles({ payload }, { call, put }) {
      const { success, data } = yield call(queryRoles);
      if (success) {
        data.map(v => {
          Object.assign(v, { key: `roleMgrList_${v.roleId}` });
          return v;
        });
        const param = {
          roleList: data,
        };
        const { roleId = null } = payload;
        if (!roleId) {
          [param.selectItem] = data;
        } else {
          let index = data.findIndex(v => v.roleId === roleId);
          if (index <= -1) index = 0;
          param.selectItem = data[index];
        }
        yield put({
          type: 'save',
          payload: {
            ...param,
          },
        });
      }
    },
    *changeRole({ payload }, { call, put }) {
      const { param, method } = payload;
      const { success, data } = yield call(editRole, param, method);
      if (success) {
        message.success(
          i18n(method === 'POST' ? 'ROLEMGR_ADD_ROLE_SUCCESS' : 'ROLEMGR_MOD_ROLE_SUCCESS')
        );
        yield put({
          type: 'queryRoles',
          payload: {
            roleId: method === 'POST' ? data.roleId : param.roleId,
          },
        });
      }
    },
    *deleteRole({ payload }, { call, put, select }) {
      const { roleId } = payload;
      const { success, data } = yield call(deleteRole, roleId);
      if (success) {
        if (data === 1) {
          message.success(i18n('ROLEMGR_DEL_ROLE_SUCCESS'));
          const { roleList } = yield select(state => state.roleMgr);
          let index = roleList.findIndex(v => v.roleId === roleId);
          if (index >= roleList.length - 1) index = roleList.length - 2;
          else index += 1;
          yield put({
            type: 'queryRoles',
            payload: {
              roleId: roleList[index].roleId,
            },
          });
        }
      }
    },
    *queryPortals({ payload }, { call, put }) {
      const { success, data } = yield call(queryPortals);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            upList: data,
            keyProp: 'portalId',
            ...payload,
          },
        });
      }
    },
    *queryPrivileges({ payload }, { call, put }) {
      const { success, data } = yield call(queryPrivileges);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            upList: data,
            keyProp: 'privId',
            ...payload,
          },
        });
      }
    },
    // 获取角色门户列表 => portal
    *queryRolePortal({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(queryRolePortal, roleId);
      if (success) {
        yield put({
          type: 'queryPortals',
          payload: {
            downList: data,
          },
        });
      }
    },
    // 获取角色权限（静态权限点）列表
    *queryRolePrivilege({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(queryRolePrivilege, roleId);
      if (success) {
        yield put({
          type: 'queryPrivileges',
          payload: {
            downList: data,
          },
        });
      }
    },
    *changeRolePortal({ payload }, { call, put }) {
      const { roleId, param, type } = payload;

      const { success, data } = type === 'add' ? yield call(changeRolePortal, roleId, param) : yield call(deleteRolePortal, roleId, param);
      if (success) {
        if (data === 'success') {
          message.success(
            i18n(type === 'add' ? 'ROLEMGR_GRANT_PORTAL_SUCCESS' : 'ROLEMGR_DEGRANT_PORTAL_SUCCESS')
          );
          yield put({
            type: 'queryRolePortal',
            payload: {
              roleId,
            },
          });
        }
      }
    },
    *changeRolePrivilege({ payload }, { call, put }) {
      const { roleId, param, type } = payload;
      const { success, data } = yield call(changeRolePrivilege, roleId, param);
      if (success) {
        if (data === 'success') {
          message.success(
            i18n(type === 'add' ? 'ROLEMGR_GRANT_PRIVILEGE_SUCCESS' : 'ROLEMGR_DEGRANT_PRIVILEGE_SUCCESS')
          );
          yield put({
            type: 'queryRolePrivilege',
            payload: {
              roleId,
            },
          });
        }
      }
    },
    // 上层menuList
    *qryMenuListByRoleParty({ payload }, { call, put, select }) {
      const { reload = false } = payload;
      const { success, data } = yield call(qryMenuListByRoleParty, payload);
      if (success) {
        const { downList } = yield select(state => state.roleMgr);
        const upList = data;
        if (reload || downList.length <= 0) {
          yield put({
            type: 'qryMenuListByRole',
            payload: {
              upList,
              ...payload,
            },
          });
        } else {
          yield put({
            type: 'saveDifference',
            payload: {
              downList,
              upList,
              keyProp: 'privId',
              keepOn: true, // 保留重复字段
              ...payload,
            },
          });
        }
      }
    },
    // 下层menuList
    *qryMenuListByRole({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(qryMenuListByRole, roleId);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            downList: data,
            keyProp: 'privId',
            keepOn: true, // 保留重复字段
            ...payload,
          },
        });
      }
    },
    // 获取portal树节点下的dirsList
    *qryDirsByParty({ payload }, { call, put }) {
      const { success, data } = yield call(qryDirsByParty, payload);
      if (success) {
        yield put({
          type: 'saveAppendMenuTree',
          payload: {
            sonList: data,
            record: payload,
          },
        });
      }
    },
    *qryDirmenusByParty({ payload }, { call, put }) {
      const { success, data } = yield call(qryDirmenusByParty, payload);
      if (success) {
        yield put({
          type: 'saveAppendMenuTree',
          payload: {
            sonList: data,
            record: payload,
          },
        });
      }
    },
    // 获取角色门户列表 => menu
    *queryRolePortalForMenu({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(queryRolePortal, roleId);
      if (success) {
        const list = formatter(data);
        if (list.length > 0) {
          const query = {
            ...list[0],
          };
          // 请求第一个节点下的子集dir
          yield put({
            type: 'qryDirsByParty',
            payload: {
              arrayList: list,
              ...query,
            },
          });
          // 请求第一个节点的菜单menu
          yield put({
            type: 'qryMenuListByRoleParty',
            payload: {
              ...query,
              ...payload,
            },
          });
        } else {
          // 请求下层menu tableList
          yield put({
            type: 'qryMenuListByRole',
            payload: {
              upList: [],
              ...payload,
            },
          });
        }
      }
    },
    *queryRolePortalAndMenu({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(queryRolePortal, roleId);
      if (success) {
        const list = formatter(data);
        if (list.length > 0) {
          const query = {
            ...list[0],
          };
          // 请求第一个节点下的子集dir
          yield put({
            type: 'qryDirmenusByParty',
            payload: {
              arrayList: list,
              ...query,
            },
          });
        }
        // 请求下层component list
        yield put({
          type: 'qryComponentListByRole',
          payload: {
            roleId,
          },
        });
      }
    },
    // 获取目录dirs
    *qryDirsByDir({ payload }, { call, put }) {
      const { dirId } = payload;
      const { success, data } = yield call(qryDirsByDir, dirId);
      if (success) {
        const list = formatterDirs(data);
        const topData = {
          dirId: -1,
          key: '-1',
          title: i18n('DIRMENUMGR_DIR_MENU_ROOT'),
          children: [],
        };
        list.push(topData);
        if (data.length > 0) {
          const query = {
            ...topData,
          };
          // 请求第一个节点的菜单menu
          yield put({
            type: 'qryMenuListByDirId',
            payload: {
              ...query,
              roleId: payload.roleId,
              arrayList: list,
            },
          });
        }
      }
    },
    // 获取目录dirs
    *loadDirsByDir({ payload }, { call, put }) {
      const { dirId } = payload;
      const { success, data } = yield call(qryDirsByDir, dirId);
      if (success) {
        yield put({
          type: 'saveAppendDirTree',
          payload: {
            sonList: data,
            record: payload,
          },
        });
      }
    },
    // 获取role目录dirs下的menuList
    *qryMenuListByDirId({ payload }, { call, put }) {
      const { success, data } = yield call(qryMenuListByDirId, payload);
      if (success) {
        yield put({
          type: 'qryMenuListByRole',
          payload: {
            upList: data,
            ...payload,
          },
        });
      }
    },
    *changeRoleComponent({ payload }, { call, put }) {
      const { roleId, param, method } = payload;
      const { success, data } = yield call(changeRoleMenu, roleId, param, method);
      if (success && data === 'success') {
        message.success(
          i18n(method === 'POST' ? 'ROLEMGR_ADD_COMPONENT_PRIV_SUCCESS' : 'ROLEMGR_RM_COMPONENT_PRIV_SUCCESS')
        );
        yield put({
          type: 'qryComponentListByRole',
          payload: {
            roleId,
          },
        });
      }
    },
    // 更改角色权限菜单
    *changeRoleMenu({ payload }, { call, put, select }) {
      const { roleId, param, method, query, activeKey } = payload;
      const { success, data } = yield call(changeRoleMenu, roleId, param, method);
      if (success && data === 'success') {
        message.success(
          i18n(method === 'POST' ? 'ROLEMGR_ADD_MENU_PRIV_SUCCESS' : 'ROLEMGR_RM_MENU_PRIV_SUCCESS')
        );
        if (activeKey !== '0') {
          yield put({
            type: 'qryMenuListByDirId',
            payload: {
              roleId,
              ...query,
            },
          });
        } else {
          let newQuery = {
            ...query,
          };
          if (JSON.stringify(query) === '{}') {
            // 默认查询第一个portal节点下的menuList
            const { menuTree } = yield select(state => state.roleMgr);
            newQuery = {
              ...newQuery,
              ...menuTree[0],
            };
          }
          yield put({
            type: 'qryMenuListByRoleParty',
            payload: {
              reload: true,
              roleId,
              ...newQuery,
            },
          });
        }
      }
    },
    *qryServiceByRole({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(qryServiceByRole, roleId);
      if (success) {
        data.map(v => {
          Object.assign(v, { key: `roleMgr_service_${v.privId}_${v.privName}` });
          return v;
        });
        yield put({
          type: 'save',
          payload: {
            serviceList: data,
          },
        });
      }
    },
    *deleteRoleService({ payload }, { call, put }) {
      const { success, data } = yield call(deleteRoleService, payload);
      if (success) {
        if (data === 1) {
          yield put({
            type: 'qryServiceByRole',
            payload: {
              ...payload,
            },
          });
        }
      }
    },
    *editRoleService({ payload }, { call, put }) {
      const { param } = payload;
      const { success } = yield call(editRoleService, param);
      if (success) {
        yield put({
          type: 'qryServiceByRole',
          payload: {
            ...payload,
          },
        });
      }
    },
    *addRoleService({ payload }, { call, put }) {
      const { roleId, param } = payload;
      const { success } = yield call(addRoleService, roleId, param);
      if (success) {
        yield put({
          type: 'qryServiceByRole',
          payload: {
            ...payload,
          },
        });
      }
    },
    // 上层component list
    *queryComponentByMenu({ payload }, { call, put, select }) {
      const { success, data } = yield call(queryComponentByMenu, payload);
      if (success) {
        const { downList } = yield select(state => state.roleMgr);
        let upList = [];
        if (data && data.length > 0) {
          upList = data.map(item => Object.assign({}, item, { menuName: payload.partyName }));
        }
        // const upList = data;
        yield put({
          type: 'saveDifference',
          payload: {
            downList,
            upList,
            keyProp: 'privId',
            keepOn: true, // 保留重复字段
          },
        });
      }
    },
    // 下层component list
    *qryComponentListByRole({ payload }, { call, put, select }) {
      const { roleId } = payload;
      const { success, data } = yield call(queryRoleComponent, roleId);
      const { upList } = yield select(state => state.roleMgr);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            downList: data,
          },
        });
        yield put({
          type: 'saveDifference',
          payload: {
            downList: data,
            upList,
            keyProp: 'privId',
            keepOn: true, // 保留重复字段
          },
        });
      }
    },
    // 下层portlet
    *qryPorletByRole({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(qryPorletByRole, roleId);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            downList: data,
            keyProp: 'portletId',
            keepOn: true, // 保留重复字段
            ...payload,
          },
        });
      }
    },
    // 获取某个portal节点下的portlets(上层portlet)
    *qryPorletByPortal({ payload }, { call, put }) {
      const { success, data } = yield call(qryPorletByPortal, payload);
      if (success) {
        const activeData = data.filter(v => v.state === 'A');
        yield put({
          type: 'qryPorletByRole',
          payload: {
            upList: activeData,
            ...payload,
          },
        });
      }
    },
    // 获取角色门户列表
    *queryRolePortalsForPortlet({ payload }, { call, put }) {
      const { roleId } = payload;
      const { success, data } = yield call(queryRolePortal, roleId);
      if (success) {
        const list = formatter(data);
        if (list.length > 0) {
          list.map(v => {
            const item = v;
            delete item.children;
            item.isLeaf = true;
            return item;
          });
          // portlet树节点下无子集
          yield put({
            type: 'save',
            payload: {
              arrayList: list,
              menuTree: list,
            },
          });
          yield put({
            type: 'qryPorletByPortal',
            payload: {
              roleId,
              portalId: list[0].portalId,
            },
          });
        } else {
          // 请求下层portlet tableList
          yield put({
            type: 'qryPorletByRole',
            payload: {
              upList: [],
              ...payload,
            },
          });
        }
      }
    },
    // 获取某类型下的portlets(上层portlet)
    *qryPorletByType({ payload }, { call, put }) {
      const { success, data } = yield call(qryPorletByType, payload);
      if (success) {
        yield put({
          type: 'qryPorletByRole',
          payload: {
            upList: data,
            ...payload,
          },
        });
      }
    },
    // 获取porlet所有类型type(当前默认为一个类型=>Default Category)
    *qryType({ payload }, { call, put }) {
      const { success, data } = yield call(qryType, payload);
      if (success) {
        if (data.length > 0) {
          // 查找默认类型下的portlet
          yield put({
            type: 'qryPorletByType',
            payload: {
              ...payload,
              ...data[0],
            },
          });
        } else {
          // 请求下层portlet tableList
          yield put({
            type: 'qryPorletByRole',
            payload: {
              upList: [],
              ...payload,
            },
          });
        }
      }
    },
    // 更改角色权限portlet
    *changeRolePortlet({ payload }, { call, put }) {
      const { roleId, param, method, activeTab } = payload;
      const { success, data } = yield call(changeRolePortlet, roleId, param, method);
      if (success && data === 'success') {
        message.success(
          i18n(method === 'POST' ? 'ROLEMGR_ADD_PORTLET_PRIV_SUCCESS' : 'ROLEMGR_RM_PORTLET_PRIV_SUCCESS')
        );
        if (activeTab !== '0') {
          // 根据目录授权
          yield put({
            type: 'qryType',
            payload: {
              roleId,
            },
          });
        } else {
          yield put({
            type: 'queryRolePortalsForPortlet',
            payload: {
              roleId,
            },
          });
        }
      }
    },
    // 获取roledata
    *qryRoleData(_, { call, put }) {
      const { success, data } = yield call(qryRoleData);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            roleDataList: data.filter(v => v.dataType === 'T'),
          },
        });
      }
    },
    *qryDataPrivs({ payload }, { call, select }) {
      const { success, data } = yield call(qryDataPrivs, payload.dataPrivId);
      const { selectItem } = yield select(state => state.roleMgr);
      if (success) {
        const findRole = data.filter(v => v.roleId === selectItem.roleId);
        if (findRole && findRole.length > 0) {
          return findRole[0].dataPrivId ? findRole[0].privValue : null;
        }
        return null;
      }
      return null;
    },
    *modifyDataPrivs({ payload }, { call, put, select }) {
      const { selectItem } = yield select(state => state.roleMgr);
      const { privValue, dataPrivId, method } = payload;
      const params = method !== 'DELETE' ? { privValue, dataPrivId, roleId: selectItem.roleId } : { dataPrivId, roleId: selectItem.roleId };
      const { success } = yield call(addRoleDataPrivs, { params, method });
      const returnMsg = () => {
        let returnData;
        switch (method) {
          case 'POST':
            returnData = i18n('ROLEMGR_DATA_ROLE_SUCCESS_ADD_DATA_PRIV');
            break;
          case 'PUT':
            returnData = i18n('ROLEMGR_DATA_ROLE_SUCCESS_MODIFY_DATA_PRIV');
            break;
          case 'DELETE':
            returnData = i18n('ROLEMGR_DATA_ROLE_SUCCESS_DELETE_DATA_PRIV');
            break;
          default:
            break;
        }
        return returnData;
      };
      if (success) {
        yield put({
          type: 'qryRoleData',
        });
        message.success(returnMsg());
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clean(state, { payload }) {
      return {
        ...state,
        ...payload,
        upList: [],
        downList: [],
        arrayList: [],
        menuTree: [],
      };
    },
    saveDifference(state, { payload }) {
      const { downList = [], upList = [], arrayList, keyProp, keepOn = false } = payload;
      let newUpTableList = [...upList];
      if (downList.length > 0) {
        const ids = [];
        downList.map(item => ids.push(item[keyProp]));
        if (keepOn) {
          // 保留差集并置disabled
          newUpTableList = upList.map(item => {
            const etem = item;
            const index = ids.findIndex(v => v === etem[keyProp]);
            if (index > -1) etem.disabled = true;
            else etem.disabled = false;
            return etem;
          });
        } else {
          // 差集
          newUpTableList = upList.filter(v => ids.indexOf(v[keyProp]) === -1);
        }
      } else {
        newUpTableList = upList.map(item => Object.assign({}, item, { disabled: false }));
      }
      const newObj = {
        ...state,
        ...payload,
        upList: uniqBy(newUpTableList, keyProp),
        downList,
      };
      if (arrayList && arrayList.length > 0) {
        newObj.arrayList = arrayList;
        newObj.menuTree = arrayToTree(arrayList, 'dirId');
      }
      return {
        ...newObj,
      };
    },
    saveAppendMenuTree(state, { payload }) {
      const { arrayList } = state;
      const { record, sonList } = payload;
      const { partyId, portalId, arrayList: parentList } = record;
      let newSonList = [];
      const pId = partyId !== 0 ? partyId : portalId;
      const pType = partyId !== 0 ? 'partyId' : 'portalId';
      newSonList = formatter(sonList, pId, pType);
      const array = arrayList.length > 0 ? arrayList : parentList;
      const list = array.concat(newSonList);
      const tree = arrayToTree(list);
      return {
        ...state,
        arrayList: list,
        menuTree: tree,
      };
    },
    saveAppendDirTree(state, { payload }) {
      const { arrayList } = state;
      const { record, sonList } = payload;
      const { arrayList: parentList } = record;
      const newSonList = formatterDirs(sonList);
      const array = arrayList.length > 0 ? arrayList : parentList;
      const list = array.concat(newSonList);
      const tree = arrayToTree(list, 'dirId');
      return {
        ...state,
        arrayList: list,
        menuTree: tree,
      };
    },
    saveCurrentUser(state, action) {
      return {
        ...state,
        currentUser: action.payload || {},
      };
    },
    changeNotifyCount(state, action) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          notifyCount: action.payload,
        },
      };
    },
    changeNowIndex(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
